import Vue from 'vue'
import Toast from 'vue-easy-toast'

Vue.use(Toast)

const defaultOptions = {
  duration: 3000,
  horizontalPosition: 'center',
  verticalPosition: 'bottom'
}

const vueEasyToast = Vue.prototype.$toast
Vue.prototype.$toast = (message, options = defaultOptions) => {
  vueEasyToast(message, options)
}



// WEBPACK FOOTER //
// ./src/plugin-config/toast.js